import { DownOutlined } from "@ant-design/icons";
import { IconButton, Modal } from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  Button,
  Dropdown,
  Image,
  Input,
  Row,
} from "antd";
import { useAlert } from "components/UI/alertSakeBar/alertProvider";
import Loading from "components/Loading";
import React, { useEffect, useState } from "react";
import styled from "styled-components";

const StyledImage = styled(Image)`
  width: 100%;
  object-fit: cover;
  max-height: 75vh;
  border-radius: 12px;
  border: 4px solid black;
`;

const ModalContent = styled.div`
  left: 50%;
  max-width: 544px;
  min-width: 450px;
  padding: 0px 24px;
  position: absolute;
  min-height: 350px;
  top: 50%;
  transform: translate(-50%, -50%);
  background-color: #fff;
  padding: 20px;
  @media only screen and (max-width: 600px) {
    min-width: 90% !important;
  }
`;
const ModalConfigArea = styled.div`
  max-height: 75vh;
  overflow: auto;
  margin-top: 10px;
  padding-top: 0px;
  padding-bottom: 0px;
  margin-top: 0px;
  margin-bottom: 0px;
  overflow: visible;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const RegenerateUsingAI = ({
  src = null,
  index,
  onImageChange,
  onGenerateHandleMedia,
  questionData,
  loaderMedia,
}) => {
  const showAlert = useAlert();
  const [promptModalVisible, setPromptModalVisible] = useState(false);
  const [prompt, setPrompt] = useState("");
  const [generating, setGenerating] = useState(false);
  const [aiImageUrl, setImageUrl] = useState(null);
  const [showImageAiPicker, setAiImagePicker] = useState(false);

  const handleGenerate = async () => {
    if (!prompt.trim()) {
      showAlert("Please enter a prompt.", "warning");
      return;
    }
    // if (!questionData?.question || questionData?.question?.length === 0) {
    //   showAlert("Please enter a question.", "warning");
    //   return;
    // }
    setGenerating(true);
    try {
      const image = await onGenerateHandleMedia(questionData, prompt);
      if (image) {
        setImageUrl(image);
        setAiImagePicker(true);
      } else {
        showAlert("Something went wrong... Please review your prompt.", "error");
      }
    } catch (error) {
      showAlert("Failed to generate image.", "error");
    } finally {
      setGenerating(false);
    }
  };

  const handleGenerateWithQuestion = async () => {
    setGenerating(true);
    try {
      const image = await onGenerateHandleMedia(questionData);
      if (image) {
        setImageUrl(image);
        setAiImagePicker(true);
        onImageChange({ url: image, index });
      } else {
        showAlert("Something went wrong... Please review your question.", "error");
      }
    } catch (error) {
      showAlert("Failed to generate image.", "error");
    } finally {
      setGenerating(false);
    }
  };

  const dropdownItems = [
    {
      key: "1",
      label: "Generate with Question",
      onClick: () => {
        handleGenerateWithQuestion();
      },
      disabled:
        !questionData?.question ||
        questionData?.loaderAudio ||
        (questionData?.type === "Fill_IN_THE_Blank" &&
          (!Array.isArray(questionData?.highlightWords) ||
            !questionData?.highlightWords?.[0]?.text)),
    },
    {
      key: "2",
      label: "Generate with Prompt",
      onClick: () => {
        setPromptModalVisible(true);
      },
    },
  ];

  useEffect(() => {
    if(src && src !== null) {
      setImageUrl(src);
      setAiImagePicker(true);
      setPrompt("");
    } else {
      setImageUrl(null);
      setAiImagePicker(false);
      setPrompt("");
    }
  }, [promptModalVisible]);

  return (
    <>
      <Dropdown  disabled={loaderMedia || generating} menu={{ items: dropdownItems }} trigger={["click"]}>
        <Button
          variant="contained"
          color="primary"
          disabled={loaderMedia || generating}
          style={{ background: "#03999e", color: "white" }}
        >
          {loaderMedia || generating ? (
            <Loading white={true} size={18} />
          ) : (
            <>
              Generate Image
              <DownOutlined />
            </>
          )}
        </Button>
      </Dropdown>

      <Modal
        open={promptModalVisible}
        onClose={() => {
          setPromptModalVisible(false);
          setAiImagePicker(false);
          setImageUrl(null);
          setPrompt("");
        }}
        style={{ height: "100%", width: "100%" }}
      >
        <ModalContent style={{ width: "60vw", minHeight: "auto" }}>
          <Row style={{ justifyContent: "space-between" }}>
            <IconButton
              onClick={() => setPromptModalVisible(false)}
              style={{ padding: 0, marginRight: 10 }}
            >
              <Close color="secondary" />
            </IconButton>
          </Row>
          <ModalConfigArea>
            {!showImageAiPicker ? (
              <Input.TextArea
                value={prompt}
                onChange={(e) => setPrompt(e.target.value)}
                rows={4}
                placeholder="Describe the image you'd like to generate..."
              />
            ) : (
              <StyledImage
                src={aiImageUrl}
                alt={`Editable image ${index + 1}`}
                preview={false}
              />
            )}
          </ModalConfigArea>
          <Row
            gutter={[24, 24]}
            style={{ marginTop: 16, marginRight: 0, marginLeft: 0, gap: 10 }}
          >
            <Button
              fullWidth
              className="generateButton"
              onClick={() => {
                if (showImageAiPicker) {
                  setAiImagePicker(false);
                  setImageUrl(null);
                } else {
                  handleGenerate();
                }
              }}
              color="primary"
              variant="contained"
              disabled={generating}
            >
              {generating ? (
                <Loading size={14} style={{ marginRight: 8 }} />
              ) : showImageAiPicker ? (
                "Re Generate"
              ) : (
                "Generate"
              )}
            </Button>
            {showImageAiPicker ? (
              <Button
                fullWidth
                onClick={() => {
                  onImageChange({ url: aiImageUrl, index });
                  setPromptModalVisible(false);
                  setAiImagePicker(false);
                  setImageUrl(null);
                }}
                className="generateButton"
                color="primary"
                variant="contained"
                disabled={generating}
              >
                {"Update Image"}
              </Button>
            ) : null}
          </Row>
        </ModalContent>
      </Modal>
    </>
  );
};

export default RegenerateUsingAI;
